// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Purchase Planning Tab (Build Note #5)
// Answers "what do I need to buy for my planned protocols?"
// All calculations via services/protocol-engine.js — no duplicate math.
// ══════════════════════════════════════════════════════

var _ppWindow = 90
var _ppSort = 'shortfall'  // 'shortfall' | 'name' | 'qty'
var _ppDetail = null       // peptideId for expanded detail

function setPPWindow(days) { _ppWindow = days; render() }
function setPPSort(sort) { _ppSort = sort; render() }
function togglePPDetail(pid) { _ppDetail = _ppDetail === pid ? null : pid; render() }

function renderPurchasePlanningTab() {
  var results = forecastInventory(S.protocols || [], S.peptides || [], S.inventoryReservations || [], _ppWindow)
  var plan = purchasePlan(results)
  var today = fmtLD(new Date())
  var endDate = fmtLD(addDays(new Date(), _ppWindow))

  // Enrich plan with vendor/price info from SKUs
  var enriched = results.map(function(r) {
    var peptide = (S.peptides || []).find(function(p) { return p.id === r.peptideId })
    var lastVendor = null
    var lastPrice = null
    var vendorObj = null
    if (peptide) {
      for (var k = 0; k < (peptide.skus || []).length; k++) {
        var sku = peptide.skus[k]
        if (sku.vendor) lastVendor = sku.vendor
        if (sku.costPerVial) lastPrice = sku.costPerVial
      }
      // Try to find matching vendor directory entry
      if (lastVendor) {
        vendorObj = (S.vendors || []).find(function(v) {
          return v.name && v.name.toLowerCase() === lastVendor.toLowerCase()
        })
      }
    }

    // Shortfall + expiring = suggested buy qty
    var suggestedQty = Math.max(0, (r.shortfall || 0))
    // Reserved elsewhere: total reserved minus what this window needs
    var reservedElsewhere = r.reserved

    return {
      peptideId: r.peptideId,
      peptideName: r.peptideName,
      totalDoses: r.totalDoses,
      totalMg: r.totalMg,
      canCalcMg: r.canCalcMg,
      totalAmount: r.totalAmount,
      amountUnit: r.amountUnit,
      canCalculate: r.canCalculate,
      onHand: r.onHand,
      reserved: r.reserved,
      reservedElsewhere: reservedElsewhere,
      available: r.available,
      vialsNeeded: r.vialsNeeded,
      shortfall: r.shortfall,
      suggestedQty: suggestedQty,
      expiringBeforeEnd: r.expiringBeforeEnd,
      earliestExpiry: r.earliestExpiry,
      skuStrengths: r.skuStrengths,
      events: r.events,
      lastVendor: lastVendor,
      lastPrice: lastPrice,
      vendorObj: vendorObj,
      estimatedCost: (lastPrice && suggestedQty > 0) ? (+lastPrice * suggestedQty).toFixed(2) : null
    }
  })

  // Sort
  if (_ppSort === 'name') {
    enriched.sort(function(a, b) { return a.peptideName.localeCompare(b.peptideName) })
  } else if (_ppSort === 'qty') {
    enriched.sort(function(a, b) { return (b.suggestedQty || 0) - (a.suggestedQty || 0) })
  } else {
    // default: shortfall desc
    enriched.sort(function(a, b) {
      var sa = a.shortfall !== null ? a.shortfall : -1
      var sb = b.shortfall !== null ? b.shortfall : -1
      return sb - sa
    })
  }

  // Summary stats
  var totalToBuy = enriched.reduce(function(s, r) { return s + (r.suggestedQty || 0) }, 0)
  var totalEstCost = enriched.reduce(function(s, r) { return s + (r.estimatedCost ? +r.estimatedCost : 0) }, 0)
  var itemsNeeded = enriched.filter(function(r) { return r.suggestedQty > 0 }).length
  var totalShortfall = enriched.filter(function(r) { return r.shortfall > 0 }).length

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Purchase Planning</h2>' +
      '<div class="spacer"></div>' +
      '<div style="display:flex;gap:4px">' +
        [30, 90, 180, 365].map(function(d) {
          return '<button class="btn btn-sm ' + (d === _ppWindow ? 'btn-primary' : 'btn-secondary') + '" onclick="setPPWindow(' + d + ')">' + d + 'd</button>'
        }).join('') +
      '</div>' +
      '<select class="form-input" style="width:auto;font-size:12px;margin-left:4px" onchange="setPPSort(this.value)">' +
        '<option value="shortfall"' + (_ppSort === 'shortfall' ? ' selected' : '') + '>Sort: Shortfall</option>' +
        '<option value="name"' + (_ppSort === 'name' ? ' selected' : '') + '>Sort: Name</option>' +
        '<option value="qty"' + (_ppSort === 'qty' ? ' selected' : '') + '>Sort: Qty Needed</option>' +
      '</select>' +
      '<button class="btn btn-secondary btn-sm" onclick="exportPurchasePlanCSV()" title="Export CSV">' + ICONS.export + ' CSV</button>' +
      '<button class="btn btn-secondary btn-sm" onclick="printPurchasePlan()" title="Print">' + ICONS.print + ' Print</button>' +
    '</div>' +

    // Summary cards
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:10px;margin-bottom:16px">' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:' + (itemsNeeded > 0 ? 'var(--amber)' : 'var(--green)') + '">' + itemsNeeded + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Items to Buy</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:var(--blue)">' + totalToBuy + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Total Vials</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:' + (totalShortfall > 0 ? 'var(--red)' : 'var(--green)') + '">' + totalShortfall + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Shortfalls</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:var(--text)">' + (totalEstCost > 0 ? '$' + totalEstCost.toFixed(0) : '\u2014') + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Est. Total Cost</div>' +
      '</div>' +
    '</div>' +

    // Planning window info
    '<div style="font-size:12px;color:var(--text4);margin-bottom:12px">' +
      'Planning window: ' + today + ' \u2192 ' + endDate + ' (' + _ppWindow + ' days)' +
    '</div>' +

    // Main table
    '<div class="card" style="padding:0;overflow:hidden">' +
      (enriched.length === 0 ?
        '<div class="empty-state" style="padding:32px"><div class="empty-icon">\uD83D\uDED2</div><p>No active protocols to plan for</p><p style="font-size:12px;color:var(--text4)">Create protocols with active status to see purchase recommendations.</p></div>' :
        '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead><tr style="border-bottom:1px solid var(--border)">' +
            '<th style="padding:10px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Peptide</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Required</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Usable</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Reserved</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Expiring</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Shortfall</th>' +
            '<th style="padding:10px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Buy Qty</th>' +
            '<th style="padding:10px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Vendor</th>' +
          '</tr></thead>' +
          '<tbody>' +
          enriched.map(function(r, i) {
            var isDetail = _ppDetail === r.peptideId
            var shortfallColor = r.shortfall > 0 ? 'var(--red)' : r.shortfall === 0 ? 'var(--green)' : 'var(--text4)'
            var buyColor = r.suggestedQty > 0 ? 'var(--amber)' : 'var(--text4)'

            return '<tr style="border-bottom:1px solid var(--border2);cursor:pointer" onclick="togglePPDetail(\'' + r.peptideId + '\')">' +
              '<td style="padding:10px 14px"><div style="font-weight:600">' + esc(r.peptideName) + '</div><div style="font-size:11px;color:var(--text4)">' + r.totalDoses + ' doses in ' + _ppWindow + 'd</div></td>' +
              '<td style="padding:10px 14px;text-align:center;font-weight:600">' + (r.vialsNeeded !== null ? r.vialsNeeded : '\u2014') + '<div style="font-size:10px;color:var(--text4);font-weight:400">' + (r.canCalculate ? r.totalAmount + ' ' + r.amountUnit : 'incompatible units') + '</div></td>' +
              '<td style="padding:10px 14px;text-align:center;font-weight:600;color:var(--blue)">' + r.available + '<div style="font-size:10px;color:var(--text4);font-weight:400">' + r.onHand + ' on hand</div></td>' +
              '<td style="padding:10px 14px;text-align:center;font-weight:600;color:var(--amber)">' + r.reservedElsewhere + '</td>' +
              '<td style="padding:10px 14px;text-align:center;font-weight:600;color:' + (r.expiringBeforeEnd > 0 ? 'var(--amber)' : 'var(--text4)') + '">' + r.expiringBeforeEnd + '</td>' +
              '<td style="padding:10px 14px;text-align:center;font-weight:700;color:' + shortfallColor + '">' + (r.shortfall !== null ? (r.shortfall > 0 ? '-' + r.shortfall : '\u2713') : '?') + '</td>' +
              '<td style="padding:10px 14px;text-align:center"><span class="badge ' + (r.suggestedQty > 0 ? 'badge-amber' : '') + '" style="font-weight:700">' + (r.suggestedQty > 0 ? r.suggestedQty : '\u2713') + '</span></td>' +
              '<td style="padding:10px 14px;font-size:12px">' +
                (r.lastVendor ? esc(r.lastVendor) + (r.lastPrice ? '<div style="font-size:11px;color:var(--text4)">$' + (+r.lastPrice).toFixed(2) + '/vial</div>' : '') : '<span style="color:var(--text4)">\u2014</span>') +
              '</td>' +
            '</tr>' +

            // Detail row
            (isDetail ? '<tr><td colspan="8" style="padding:0;background:var(--bg3)">' +
              '<div style="padding:12px 14px;display:grid;grid-template-columns:1fr 1fr;gap:12px">' +
                // Left: calculation breakdown
                '<div style="background:var(--bg);border-radius:var(--r2);padding:12px">' +
                  '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">Calculation Detail</div>' +
                  '<div style="font-size:12px;line-height:1.8">' +
                    '<div>Planned doses: <b>' + r.totalDoses + '</b></div>' +
                    (r.canCalculate ? '<div>Total required: <b>' + r.totalAmount + ' ' + r.amountUnit + '</b></div>' : '<div style="color:var(--amber)">Dose and vial units are not compatible</div>') +
                    (r.skuStrengths.length > 0 ? '<div>SKU strengths: ' + r.skuStrengths.map(function(s) { return s.amount + ' ' + s.unit + ' \u00d7' + s.qty }).join(', ') + '</div>' : '<div style="color:var(--amber)">No compatible SKU strength data</div>') +
                    '<div>On hand: ' + r.onHand + ' | Reserved: ' + r.reserved + ' | Available: ' + r.available + '</div>' +
                    (r.vialsNeeded !== null ? '<div>Vials needed: <b>' + r.vialsNeeded + '</b></div>' : '') +
                    (r.shortfall !== null && r.shortfall > 0 ? '<div style="color:var(--red);font-weight:600">\u26A0 Shortfall: ' + r.shortfall + ' vials</div>' : '') +
                    (r.expiringBeforeEnd > 0 ? '<div style="color:var(--amber)">' + r.expiringBeforeEnd + ' vial(s) expire before ' + endDate + '</div>' : '') +
                    '<div style="font-weight:600;margin-top:4px">Suggested purchase: ' + r.suggestedQty + ' vials' + (r.estimatedCost ? ' \u2248 $' + r.estimatedCost : '') + '</div>' +
                    '<button class="btn btn-ghost btn-xs" style="margin-top:4px" onclick="event.stopPropagation();explainForecastCalc(\'' + r.peptideId + '\')">\uD83E\uDD16 Why this number?</button>' +
                  '</div>' +
                '</div>' +
                // Right: vendor + next doses
                '<div style="background:var(--bg);border-radius:var(--r2);padding:12px">' +
                  '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">Vendor & Schedule</div>' +
                  '<div style="font-size:12px;line-height:1.8">' +
                    (r.lastVendor ? '<div>Last vendor: <b>' + esc(r.lastVendor) + '</b></div>' : '<div style="color:var(--text4)">No vendor on record</div>') +
                    (r.lastPrice ? '<div>Last price: <b>$' + (+r.lastPrice).toFixed(2) + '/vial</b></div>' : '') +
                    (r.vendorObj && r.vendorObj.website ? '<div><a href="' + esc(r.vendorObj.website) + '" target="_blank" rel="noopener" style="color:var(--accent)">' + esc(r.vendorObj.website) + '</a></div>' : '') +
                    (r.earliestExpiry ? '<div style="margin-top:6px">Earliest expiry: <span style="color:' + (r.earliestExpiry <= today ? 'var(--red)' : r.earliestExpiry <= endDate ? 'var(--amber)' : 'var(--text3)') + '">' + r.earliestExpiry + '</span></div>' : '') +
                    '<div style="margin-top:8px;font-size:11px;color:var(--text4)">Next 5 doses:</div>' +
                    '<div style="font-size:11px;color:var(--text3)">' + r.events.slice(0, 5).map(function(e) { return e.date.slice(5) + ' ' + e.doseAmount + ' ' + e.doseUnit + (e.phaseName ? ' (' + e.phaseName + ')' : '') }).join('<br>') + '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div style="padding:0 14px 12px;display:flex;gap:6px">' +
                '<button class="btn btn-secondary btn-xs" onclick="setTab(\'forecast\')">Full Forecast</button>' +
                '<button class="btn btn-secondary btn-xs" onclick="setTab(\'allocation\')">Allocations</button>' +
                '<button class="btn btn-secondary btn-xs" onclick="setTab(\'vendors\')">Vendors</button>' +
              '</div>' +
            '</td></tr>' : '')
          }).join('') +
          '</tbody></table>'
      ) +
    '</div>' +
  '</div>'
}

// ── CSV Export ──
function exportPurchasePlanCSV() {
  var results = forecastInventory(S.protocols || [], S.peptides || [], S.inventoryReservations || [], _ppWindow)
  var rows = [['Peptide', 'Required (vials)', 'Required Amount', 'Required Unit', 'On Hand', 'Available', 'Reserved', 'Expiring', 'Shortfall', 'Suggested Buy', 'Last Vendor', 'Price/Vial', 'Est. Cost']]
  results.forEach(function(r) {
    var peptide = (S.peptides || []).find(function(p) { return p.id === r.peptideId })
    var lastVendor = '', lastPrice = ''
    if (peptide) {
      for (var k = 0; k < (peptide.skus || []).length; k++) {
        if (peptide.skus[k].vendor) lastVendor = peptide.skus[k].vendor
        if (peptide.skus[k].costPerVial) lastPrice = peptide.skus[k].costPerVial
      }
    }
    var suggestedQty = Math.max(0, (r.shortfall || 0))
    var estCost = lastPrice && suggestedQty > 0 ? (+lastPrice * suggestedQty).toFixed(2) : ''
    rows.push([
      r.peptideName,
      r.vialsNeeded !== null ? r.vialsNeeded : '',
      r.canCalculate ? r.totalAmount : '',
      r.canCalculate ? r.amountUnit : '',
      r.onHand,
      r.available,
      r.reserved,
      r.expiringBeforeEnd,
      r.shortfall !== null ? r.shortfall : '',
      suggestedQty,
      lastVendor,
      lastPrice,
      estCost
    ])
  })
  var csv = rows.map(function(r) { return r.map(function(c) { return '"' + String(c).replace(/"/g, '""') + '"' }).join(',') }).join('\n')
  var blob = new Blob([csv], { type: 'text/csv' })
  var a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = 'PeptideVault_PurchasePlan_' + _ppWindow + 'd_' + fmtLD(new Date()) + '.csv'
  a.click()
  URL.revokeObjectURL(a.href)
  showToast('Purchase plan exported')
}

// ── Print ──
function printPurchasePlan() {
  var w = window.open('', '_blank')
  if (!w) { showToast('Pop-up blocked'); return }
  var results = forecastInventory(S.protocols || [], S.peptides || [], S.inventoryReservations || [], _ppWindow)
  var today = fmtLD(new Date())
  var endDate = fmtLD(addDays(new Date(), _ppWindow))
  var html = '<html><head><title>Purchase Plan</title><style>body{font-family:-apple-system,sans-serif;padding:24px;font-size:13px}h1{font-size:18px;margin:0 0 4px}table{width:100%;border-collapse:collapse;margin-top:12px}th,td{border:1px solid #ccc;padding:6px 10px;text-align:left;font-size:12px}th{background:#f5f5f5;font-weight:700;text-transform:uppercase;font-size:10px}.shortfall{color:red;font-weight:700}</style></head><body>'
  html += '<h1>PeptideVault \u2014 Purchase Plan</h1>'
  html += '<div style="color:#888;font-size:12px">' + today + ' \u2192 ' + endDate + ' (' + _ppWindow + ' days)</div>'
  html += '<table><thead><tr><th>Peptide</th><th>Needed</th><th>Available</th><th>Shortfall</th><th>Expiring</th><th>Buy Qty</th><th>Vendor</th><th>$/Vial</th></tr></thead><tbody>'
  results.forEach(function(r) {
    var peptide = (S.peptides || []).find(function(p) { return p.id === r.peptideId })
    var v = '', pr = ''
    if (peptide) { for (var k = 0; k < (peptide.skus || []).length; k++) { if (peptide.skus[k].vendor) v = peptide.skus[k].vendor; if (peptide.skus[k].costPerVial) pr = peptide.skus[k].costPerVial } }
    var sq = Math.max(0, (r.shortfall || 0))
    html += '<tr><td>' + esc(r.peptideName) + '</td><td>' + (r.vialsNeeded !== null ? r.vialsNeeded : '\u2014') + '</td><td>' + r.available + '</td><td class="' + (r.shortfall > 0 ? 'shortfall' : '') + '">' + (r.shortfall !== null ? r.shortfall : '?') + '</td><td>' + r.expiringBeforeEnd + '</td><td style="font-weight:700">' + sq + '</td><td>' + esc(v) + '</td><td>' + (pr ? '$' + (+pr).toFixed(2) : '') + '</td></tr>'
  })
  html += '</tbody></table></body></html>'
  w.document.write(html)
  w.document.close()
  w.print()
}

// Item 24: AI explain calculation
async function explainForecastCalc(peptideId) {
  if (typeof aiExplainCalculation !== 'function') { showToast('AI service not available'); return }
  showToast('Asking AI...')
  var results = forecastInventory(S.protocols || [], S.peptides || [], S.inventoryReservations || [], _ppWindow)
  var r = results.find(function(x) { return x.peptideId === peptideId })
  if (!r) { showToast('Forecast data not found'); return }
  var result = await aiExplainCalculation('Inventory Forecast', r)
  if (result.ok) { openModal('aiExplain', { title: r.peptideName + ' Forecast', content: result.content }); render() }
  else showToast('AI error: ' + result.error)
}

export {
  _ppWindow,
  _ppSort,
  _ppDetail,
  setPPWindow,
  setPPSort,
  togglePPDetail,
  renderPurchasePlanningTab,
  exportPurchasePlanCSV,
  printPurchasePlan,
  explainForecastCalc
}
